import { parseApiError } from '../errors/parseApiError';

export const hasError = (state, requestType /* ,  dispatch */) => {
  if (!state[requestType]) {
    return false;
  }
  const { error } = state[requestType];
  if (error) {
    return parseApiError(error).toastMessage;
  }
  return false;
};
